import { SVGProps } from 'react';

export function ChevronLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 13' {...props}>
      <path
        strokeWidth='1'
        stroke='currentColor'
        fill='none'
        d='m6.697 12.5-6-6.182L6.344.5'
      />
    </svg>
  );
}
